const BENIGN_WINDOW_ERROR_MESSAGES = new Set([
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
]);

export const isIgnorableGlobalWindowErrorMessage = (
  message?: string | null,
): boolean => {
  return typeof message === "string" && BENIGN_WINDOW_ERROR_MESSAGES.has(message);
};

export const serializeUnhandledRejectionReason = (
  reason: unknown,
): unknown => {
  if (reason instanceof Error) {
    return {
      name: reason.name,
      message: reason.message,
      stack: reason.stack,
    };
  }

  if (reason && typeof reason === "object") {
    const details = reason as {
      name?: unknown;
      message?: unknown;
      stack?: unknown;
      code?: unknown;
    };
    const serialized: Record<string, unknown> = {
      type: reason.constructor?.name || "Object",
    };

    if (details.name !== undefined) {
      serialized.name = details.name;
    }
    if (details.message !== undefined) {
      serialized.message = details.message;
    }
    if (details.stack !== undefined) {
      serialized.stack = details.stack;
    }
    if (details.code !== undefined) {
      serialized.code = details.code;
    }

    try {
      const json = JSON.stringify(reason);
      if (json && json !== "{}") {
        serialized.json = json;
      }
    } catch {
      // Keep the structured fields above when the object cannot be stringified.
    }

    return serialized;
  }

  return reason;
};
